import { Toaster } from "react-hot-toast";
import Layout from "./shared/Layout";
import { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { API_URL, baseurl } from "../_config";

const VanuePartnerList = () => {
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [userList, setUserList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchuserList = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getPartnerDetail}`);
            if (response?.data?.isSuccess === 1) {
                setUserList(response?.data?.data)
            }
        } catch (error) {
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchuserList();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = userList?.filter(item =>
                (item.name && item.name.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.phoneNumber && item.phoneNumber.toString().includes(searchTerm.toString())) ||
                (item.emailAddress && item.emailAddress.toString().includes(searchTerm.toLowerCase()))
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(userList);
        }
    }, [searchTerm, userList]);

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '60px',
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Email Id',
            selector: row => (
                <div className="" >
                    <h6>{row.emailAddress}</h6>
                    <span>{row?.phoneNumber}</span>
                </div>
            ),
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'AddressOfVenue',
            selector: row => row.addressOfVenue,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Position',
            selector: row => row.position,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Organisation Name',
            selector: row => row.organisationName,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'EventName',
            selector: row => row.eventName,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'EventVenue',
            selector: row => row.eventVenue,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'VenueName',
            selector: row => row.venueName,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'VenueServices',
            selector: row => row.venueServices,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'VenueAddress',
            selector: row => row.venueAddress,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Event Start Date',
            selector: row => {
                if (row.eventStartDate) {
                    const date = new Date(row.eventStartDate);
                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0');
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: false,
            minWidth: '180px'
        },
        {
            name: 'Event End Date',
            selector: row => {
                if (row.eventEndDate) {
                    const date = new Date(row.eventEndDate);
                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0');
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: false,
            minWidth: '180px'
        },
        {
            name: 'Changing Room Availability',
            selector: row => row.changingRoomAvailability,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'RefreshmentStalls',
            selector: row => row.refreshmentStalls,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'RestingAreaForPlayers',
            selector: row => row.restingAreaForPlayers,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'MedicalFirstAidFacilities',
            selector: row => row.medicalFirstAidFacilities,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'City',
            selector: row => row.city,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: false,
            minWidth: '120px'

        },
        {
            name: 'Pincode',
            selector: row => row.postalCode,
            sortable: false,
            minWidth: '120px'
        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Vanue Partner List</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                {error ? (
                    <p>Data not avaiable</p>
                ) : (
                    <div className="datatable mt-4">
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default VanuePartnerList;